export default __webpack_public_path__ + "media/images/footer-logo-288e62285e67c64ed67d0f1aaa5e7910.png";